import React, {useState} from "react";
import GetStatuses, {StatusInterface} from "../../functions/GetStatuses";

import "./styles/Status.css"


export interface StatusProps {
    status_id: number
}

const Status: React.FunctionComponent<StatusProps> = ({ status_id }) => {

    const [status] = useState<StatusInterface>(GetStatuses.getStatus(status_id))

    return <span className="Status" style={{background: status.bg_color}}>
        {status.option}
    </span>

}

export default Status